<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师奖金设置' url='/basicInfo/scholarship/teclist'></SearchTitle>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body" style="padding: 2rem 2.2rem;">
          <!--begin: Form Body -->
          <el-table v-loading="loading" :data="form.tableData" style="width: 100%;margin-bottom: 20px;" row-key="id"
            border default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="" label="带教老师奖金" align="center">
              <el-table-column prop="CPIMTypeName" label="年制" align="center" width="300">
              </el-table-column>
              <el-table-column prop="CPIMName" label="基数名称" align="center" width="300">
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Money" label="金额" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Money"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
          <div class="m-form__actions m-form__actions--solid">
            <div class="row">
              <div class="col-lg-12 m--align-center">
                <SaveButton :url='saveUrl' back="/basicInfo/scholarship/teclist"></SaveButton>
                <SearchButton :url='searchUrl' ref="btnSearch" :level="2" :hasform="true" style="display: none;"></SearchButton>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'TecScholarshipList',
    data() {
      return {
        condition: {
          type: '1',
          token: sessionStorage.getItem('token')
        },
        form: {
          token: sessionStorage.getItem('token'),
          tableData: [{
            type: '1',
            CPIMID: '',
            CPIMTypeName: '',
            CPIMName: '',
            CPIMType: '',
            Accommodation: '',
            Restaurant: '',
            Traffic: '',
            Attendance: '',
            Provincial: '',
            Municipal: '',
            Other: '',
            Money: ''
          }],
          condition: {
            recordCount: ''
          }
        },
        searchUrl: this.$utils.Url.zpgl + '/api/APICPIMoneySet/List',
        saveUrl: this.$utils.Url.zpgl + '/api/APICPIMoneySet/Add',
        loading: true
      }
    },
    methods: {
      Save() {
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICPIMoneySet/Add', this.form.tableData, null, null, null,
          null)
      }
    },
    mounted: function() {
      this.$refs.btnSearch.Search()
    }
  }
</script>
